import { render, staticRenderFns } from "./OpenEndedLayout.vue?vue&type=template&id=2f337ef4&scoped=true&"
import script from "./OpenEndedLayout.vue?vue&type=script&lang=js&"
export * from "./OpenEndedLayout.vue?vue&type=script&lang=js&"
import style0 from "./OpenEndedLayout.vue?vue&type=style&index=0&id=2f337ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f337ef4",
  null
  
)

export default component.exports